import {
  SELECT_ROW,
  SELECT_ROW_BY_ROW_INDEX,
  RESET_SELECTION_STATE,
} from './types';

export const selectRow = ({ name, fields, data }) => {
  const values = fields.reduce((result, field) => ({
    ...result,
    [field]: data[field],
  }), {});

  return {
    type: SELECT_ROW,
    payload: {
      name,
      fields,
      values,
    },
  };
};

export const selectRowByRowIndex = rowIndex => ({
  type: SELECT_ROW_BY_ROW_INDEX,
  rowIndex,
});

export const resetSelectionState = () => ({
  type: RESET_SELECTION_STATE,
});
